module.exports = __webpack_public_path__ + "img/jacket-front-sub-setIn-hood.8495aecf.png";